import type { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  icon?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  icon,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div className={`flex flex-col ${centered ? "items-center text-center" : "items-start"} mb-8 md:mb-12`}>
      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-label font-medium tracking-wide">
        {icon && <i className={`${icon} text-sm`}></i>}
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
        {title}
      </h2>
      {description && (
        <p className={`mt-3 text-sm md:text-base text-foreground-600 leading-relaxed ${centered ? "max-w-3xl" : "max-w-2xl"}`}>
          {description}
        </p>
      )}
    </div>
  );
}

export function CardWrap({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={`rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-200 ${className}`}
    >
      {children}
    </div>
  );
}